import { getFile } from "api/fileManager";

const pdfPreviewConfig = {
  getFile
};

export default pdfPreviewConfig;